import React, { createContext, useState } from 'react';


export const SharedInfoContext = createContext();

export const SharedInfoContextProvider = ({ children }) => {
	const [contextValue, setContextValue] = useState(
		{
			"terminalCode":"",
			"storeCode":"",
			"token":"",
			"gateFlag":"",
			"frontGateQR":"",
			"exitGateQR":"",
			"signNumber":"",
			"registerNumber":"",
			"intervalFlg":true,
			"storeInfo":[],
			"bandColor":"#CE57AF",
			"transactionno":"",
			"lastTimeStoreCode":null,
			"glocation":"",
			"favStore":[],
			"otbCode":"",
			"appInfo":[],
			"dammingCheckRunInterval":"",
			"aeonPayFlg":"0",
			"aeonPayVerCheck":false,
			"memberCodeVerCheck":false
		}
	);

	const updateTerminalCode = (newTerminalCode) => {
		setContextValue(current => ({ ...current, terminalCode: newTerminalCode }));
	};
	const updateStoreCode = (newStoreCode) => {
		setContextValue(current => ({ ...current, storeCode: newStoreCode }));
	};
	const updateToken = (newToken) => {
		setContextValue(current => ({ ...current, token: newToken }));
	};
	const updateGateFlag = (newGateFlag) => {
		setContextValue(current => ({ ...current, gateFlag: newGateFlag }));
	};
	const updateExitGateQR = (newExitGateQR) => {
		setContextValue(current => ({ ...current, exitGateQR: newExitGateQR }));
	};
	const updateSignNumber = (newSignNumber) => {
		setContextValue(current => ({ ...current, signNumber: newSignNumber }));
	};
	const updateRegisterNumber = (newRegisterNumber) => {
		setContextValue(current => ({ ...current, registerNumber: newRegisterNumber }));
	};
	const updateIntervalFlg = (newIntervalFlg) => {
		setContextValue(current => ({ ...current, intervalFlg: newIntervalFlg }));
	};
	const updateStoreInfo = (newStoreInfo) => {
		setContextValue(current => ({ ...current, storeInfo: newStoreInfo }));
	};
	const updateFrontGateQR = (newFrontGateQR) => {
		setContextValue(current => ({ ...current, frontGateQR: newFrontGateQR }));
	};
	const updateBandColor = (newBandColor) => {
		setContextValue(current => ({ ...current, bandColor: newBandColor }));
	};
	const updateTransactionno = (newTransactionno) => {
		setContextValue(current => ({ ...current, transactionno: newTransactionno }));
	};
	const updateLastTimeStoreCode = (newLastTimeStoreCode) => {
		setContextValue(current => ({ ...current, lastTimeStoreCode: newLastTimeStoreCode }));
	};
	const updategLocation = (newgLocation) => {
		setContextValue(current => ({ ...current, glocation: newgLocation }));
	};
	const updateFavStore = (newFavStore) => {
		setContextValue(current => ({ ...current, favStore: newFavStore }));
	};
	const updateOtbCode = (newOtbCode) => {
		setContextValue(current => ({ ...current, otbCode: newOtbCode }));
	};
	const updateAppInfo = (newAppInfo) => {
		setContextValue(current => ({ ...current, appInfo: newAppInfo }));
	};
	const updateDammingCheckRunInterval = (newDammingCheckRunInterval) => {
		setContextValue(current => ({ ...current, dammingCheckRunInterval: newDammingCheckRunInterval }));
	};
	const updateAeonPayFlg = (newAeonPayFlg) => {
		setContextValue(current => ({ ...current, aeonPayFlg: newAeonPayFlg }));
	};
	const updateAeonPayVerCheck = (newAeonPayVerCheck) => {
		setContextValue(current => ({ ...current, aeonPayVerCheck: newAeonPayVerCheck }));
	};
	const updateMemberCodeVerCheck = (newMemberCodeVerCheck) => {
		setContextValue(current => ({ ...current, memberCodeVerCheck: newMemberCodeVerCheck }));
	};

	return (
		<SharedInfoContext.Provider value={{ ...contextValue, updateTerminalCode, updateStoreCode, updateToken, updateGateFlag, updateExitGateQR, updateSignNumber, updateRegisterNumber, updateIntervalFlg, updateStoreInfo,updateFrontGateQR, updateBandColor, updateTransactionno, updateLastTimeStoreCode, updategLocation, updateFavStore, updateOtbCode, updateAppInfo, updateDammingCheckRunInterval, updateAeonPayFlg, updateAeonPayVerCheck, updateMemberCodeVerCheck }}>
		{children}
		</SharedInfoContext.Provider>
	);
}
